export function ordinal(num: number) {
  const suffix = ["th", "st", "nd", "rd"];
  const idx = num % 100;
  return `${num}${suffix[(idx - 20) % 10] || suffix[idx] || suffix[0]}`;
}

export function round(num: number, decimals = 0) {
  const magnitude = +"1".padEnd(decimals + 1, "0");
  return Math.round(num * magnitude) / magnitude;
}
